import { IS_DEV_CONFIG } from '@constants';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import VConsole from 'vconsole';
import App from './App';
import AppSensors from './components/appSensors';
import reportWebVitals from './reportWebVitals';
if (IS_DEV_CONFIG) {
  new VConsole();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <RecoilRoot>
    <AppSensors>
      <App />
    </AppSensors>
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
